import Action from './action';

const initialState = {
    verifyCode: '',
    disableBtn: false,
    errorText: ''
}

export default (state = initialState, action: {type: string, playload: string[] | string}) => {
    switch (action.type) {
        case Action.UPDATE_VERIFY_CODE: {
            return {
                ...state,
                verifyCode: action.playload
            }
        }
        case Action.UPDATE_DISABLE_BTN: {
            return {
                ...state,
                disableBtn: action.playload
            }
        }
        case Action.UPDATE_VERIFY_INPUT_ERROR_TEXT: {
            return {
                ...state,
                errorText: action.playload
            }
        }
        default: return state;
    }
}
